import { render, staticRenderFns } from "./PushNotificationsEditor.vue?vue&type=template&id=3f2a2504&scoped=true&"
import script from "./PushNotificationsEditor.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsEditor.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationsEditor.vue?vue&type=style&index=0&id=3f2a2504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2a2504",
  null
  
)

export default component.exports